module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "progress shadow-box"
  }, [_c('div', {
    staticClass: "progress__circle",
    class: _vm.percentageClass
  }, [(_vm.status == 'new') ? _c('span', [_c('i', {
    staticClass: "fa fa-rocket"
  })]) : (_vm.status == 'finished') ? _c('span', [_c('i', {
    staticClass: "fa fa-check"
  })]) : _c('span')])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-252dec8e","preserveWhitespace":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./public/js/components/progress-assessment.vue
// module id = ./node_modules/vue-loader/lib/template-compiler/index.js?{"id":"data-v-252dec8e","preserveWhitespace":false}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./public/js/components/progress-assessment.vue
// module chunks = 0